var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"mb-4"},[_vm._l((_vm.content),function(ref){
var heading = ref[0];
var blocks = ref[1];
return (blocks.length)?[_c('h4',{attrs:{"id":heading}},[_vm._v(_vm._s(_vm._f("translate")(_vm._f("capitalize")(_vm._f("humanize")(heading)))))]),_vm._v(" "),_vm._l((blocks),function(block){return (block.type === 'paragraph' || block.type === 'material')?_c('paragraph',_vm._b({key:block.id},'paragraph',block.value,false)):_vm._e()})]:_vm._e()})],2)}
var staticRenderFns = []

export { render, staticRenderFns }